import { OrganizationPermission, Role } from '@gm-commercial/profile-model';
import { REPORTS_FLAG } from '~/common/models/featureFlags.model';

import { RouteName } from '~/common/models/route.model';
import { lazyWithReload } from '~/common/utils/lazyWithReload';

const ReportsView = lazyWithReload(
  () => import('~/routes/organizations/reports/ReportsView')
);

export const REPORTS_ACCESS_ROLES: Role[] = [
  Role.ORG_MANAGER,
  Role.FLEET_MANAGER,
  Role.SYSTEM_MANAGER,
  Role.SYSTEM_READER,
];

export enum ReportTypes {
  TRIP_HISTORY = 'TRIP_HISTORY',
  SAFETY_EVENTS = 'SAFETY_EVENTS',
  HOME_CHARGING = 'HOME_CHARGING',
  UTILIZATION = 'UTILIZATION',
}

export const USER_ACTIVITY_AUDIT_CATEGORIES = [
  'REMOTE_COMMANDS',
  'BOARDING',
] as const;

export const USER_ACTIVITY_AUDIT_EVENT_TYPES = [
  'LOCK_DOORS',
  'UNLOCK_DOORS',
  'START_ENGINE',
  'ONBOARD',
  'OFFBOARD',
] as const;

export const USER_ACTIVITY_EXPORT_DAYS_RANGE = 365;

/**
 * Width of the search box in the report filter tabs. It has to hold the longest
 * placeholder among the launched locales after its icon and padding take about 50px.
 */
export const REPORT_FILTER_SEARCH_WIDTH = '340px';

export enum ReportsTab {
  STANDARD = 'standard',
  SCHEDULED = 'scheduled',
}

const ORGANIZATIONS_REPORTS_ROUTES = {
  [RouteName.ORGANIZATIONS_REPORTS]: {
    name: RouteName.ORGANIZATIONS_REPORTS,
    path: '/organizations/:organizationsId/reports',
    authorizedPerms: [OrganizationPermission.READ],
    authorizedRoles: REPORTS_ACCESS_ROLES,
    element: ReportsView,
    requiredFeatureFlags: [REPORTS_FLAG],
  },
};

export default ORGANIZATIONS_REPORTS_ROUTES;
